<template>
  <md-input
      type="text"
      v-only-float
      v-model="displayValue"
      @blur="isInputActive=false"
      @focus="isInputActive=true"
      @keypress="onKeypress"
  />
</template>

<script>
export default {
  name: "PriceWings",
  props: {
    value: {
      type: String|Number,
      default: ""
    },
    fractionDigits: {
      type: Number,
      default: 2
    },
    isNegativeAllowed: {
      type: Boolean,
      default: false
    },
    isNullable: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function() {
        if (this.isInputActive) {
          // Cursor is inside the input field. unformat display value for user
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface
          let result;

          if (!isNaN(this.value) && this.value != '') {
            result = parseFloat(this.value).toFixed(this.fractionDigits);
          } else {
            result = '';
          }
          return result;
          /* return (this.value && !isNaN(this.value)) ? parseFloat(this.value).toFixed(this.fractionDigits) : '' */
        }
      },
      set: function(modifiedValue) {
        // Recalculate value after ignoring non numeric symbols in user input
        let newValue = modifiedValue
            ? parseFloat(modifiedValue.replace(this.isNegativeAllowed ? /[^-\d\.]/g : /[^\d\.]/g, "")) : undefined;

        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = undefined;
        }
        // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
        // $emit the event so that parent component gets it
        if (newValue == undefined) {
          this.$emit('input', undefined);
        } else {
          this.$emit('input', newValue.toString());
        }
      }
    }
  },
  methods: {
    countDecimals(num) {
      let text = num.toString()
      if (text.indexOf('e-') > -1) {
        let [base, trail] = text.split('e-')
        let elen = parseInt(trail, 10)
        let idx = base.indexOf(".")
        return idx == -1 ? 0 + elen : (base.length - idx - 1) + elen
      }
      let index = text.indexOf(".")
      return index == -1 ? 0 : (text.length - index - 1)
    },
    onKeypress($event) {
      let check = this.isNegativeAllowed ? /[^-\d]/g.test($event.key) : /[^\d]/g.test($event.key);
      if (check) {
        if ($event.key === '.' && !this.value.includes('.')) {
          return;
        }
        $event.preventDefault();
      }
    }
  }
}
</script>
